

const setView = (show, el, vnode) => {
    if (!show) {
        const comment = document.createComment(' ')
        Object.defineProperty(comment, 'setAttribute', {
            value: () => undefined,
        })
        vnode.elm = comment
        vnode.text = ' '
        vnode.isComment = true
        vnode.context = undefined
        vnode.tag = undefined
        vnode.data.directives = undefined
        if (vnode.componentInstance) {
            vnode.componentInstance.$el = comment
        }
        if (el.parentNode) {
            el.parentNode.replaceChild(comment, el)
        }
    }
}

const verify = (values, stores) => {
    let found = false
    for (const value in values) {
        for (const store in stores) {
            if (values[value] == stores[store]) {
                found = true
                break
            }
        }
        if (found) break
    }
    return found
}

export default {
    install: (Vue, store) => {
        Vue.prototype.$can = permissions => verify(permissions, store.state.acl.permissions)
        Vue.prototype.$rol = roles => verify(roles, store.state.acl.roles)
        Vue.directive('can', {
            bind(el, binding, vnode) {
                const result = verify(binding.value, store.state.acl.permissions)
                //setView(result, el, vnode)
                el.style.display = (result) ? el._display : 'none'
            },
        })
        Vue.directive('rol', {
            bind(el, binding, vnode) {
                const result = verify(binding.value, store.state.acl.roles)
                //setView(result, el, vnode)
                el.style.display = (result) ? el._display : 'none'
            },
        })
    },
}
